import { useDrawerState } from '~/hooks/useDrawerState';
import TestViewDrawer from './TestViewDrawer';

export function TestDrawer() {
  const { id: testId, opened, closeDrawer } = useDrawerState({ queryKey: 'testDrawer' });

  return (
    <TestViewDrawer
      testId={testId}
      opened={opened}
      onClose={closeDrawer}
      initialTab="details"
    />
  );
}
